import BaseModel from '../BaseModel';

export default class candidateTestScore extends BaseModel {
  static entity = 'candidateTestScore';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      candidateId: this.attr(null),
      createdAt: this.string(null).nullable(),
      passed: this.boolean(false).nullable(),
      score: this.string(null).nullable(),
      testId: this.attr(null),
    };
  }
}
